// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__IBM_Plex_Sans_67235b', '__IBM_Plex_Sans_Fallback_67235b'","fontStyle":"normal"},"className":"__className_67235b","variable":"__variable_67235b"};